// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"188":"6cbbcb8b","191":"fed9ba8f","274":"b48b7b4d","463":"883953e4","614":"b50c82ae","920":"6af279af"}[chunkId] + ".css";
};